var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.97505 1.05806C1.21913 0.813981 1.61486 0.813981 1.85893 1.05806L6.41699 5.61612L10.9751 1.05806C11.2191 0.813981 11.6149 0.813981 11.8589 1.05806C12.103 1.30214 12.103 1.69786 11.8589 1.94194L6.85893 6.94194C6.61486 7.18602 6.21913 7.18602 5.97505 6.94194L0.97505 1.94194C0.730973 1.69786 0.730973 1.30214 0.97505 1.05806Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDown);
export default __webpack_public_path__ + "static/media/list_down.2a6c95231bd8657aaf24dd539c21a40d.svg";
export { ForwardRef as ReactComponent };